module.exports = __webpack_public_path__ + "img/down-yn1.2651f647.png";